// @flow
import { BroadcastMonth } from 'broadcastCalendar/BroadcastMonth';

type InvoiceStatus = 'BILLED' | 'NOT_BILLED';

interface Cost {
  amount: number;
}

interface Customer {
  name: string;
  campaigns: [{
    name: string;
    cost: Cost;
    salesCommissionCost: Cost;
    numberOfSpots: number;
    numberOfPlayedSpots: number;
  }];
  total: Cost;
  salesCommissionTotal: Cost;
}

export default class RadioCampaignInvoice {
  radio: string;
  salesCommission: number;
  total: Cost;
  salesCommissionTotal: Cost;
  customers: Customer[];
  month: BroadcastMonth;
  status: InvoiceStatus;

  constructor(total: Cost, salesCommissionTotal: Cost, salesCommission: number, customers: Customer[], callSign: string, month: BroadcastMonth, status: InvoiceStatus) {
    this.total = total;
    this.customers = customers;
    this.salesCommissionTotal = salesCommissionTotal;
    this.salesCommission = salesCommission;
    this.radio = callSign;
    this.month = month;
    this.status = status;
  }

  isBilled() {
    return this.status === 'BILLED';
  }

  static parse(data: any) {
    const month = BroadcastMonth.parse(data.broadcastMonth);
    return new RadioCampaignInvoice(data.total, data.salesCommissionTotal, data.salesCommission, data.customers, data.radio, month, data.status);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/billing/domain/RadioCampaignInvoice.js